import React, { useState } from "react";
import { Switch, Route, NavLink, withRouter } from "react-router-dom";
import { Card } from "@blueprintjs/core";
import styled from "styled-components";

import { withAuthentication } from "../Session";

import Live from "../../pages/Live";
import SignUp from "../../pages/SignUp";
import SignIn from "../../pages/SignIn";

import Gallery from "../../pages/Gallery";
import Art from "../../pages/Art";

import Scripts from "../../pages/Scripts";
import Script from "../../pages/Script";

import Slideshows from "../../pages/Slideshows";
// import Slideshow from "../../pages/Slideshow";

import Sidebar from "../Sidebar";
import Logo from "../Logo";

import AppNavbar from "./AppNavbar";
import Launcher from "./Launcher";

const Container = styled.div`
  display: flex;
  background: hsl(240, 3%, 12%);
  height: 100vh;
  align-items: stretch;
  font-size: 1rem;
`;

const Main = styled.div`
  flex: 1;
  align-self: stretch;
  display: flex;
  flex-direction: column;
`;

const WorkArea = styled.div`
  display: flex;
  flex: 1;
`;

const MobileOverlay = styled.div`
  position: fixed;
  background: hsl(240, 3%, 12%);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const App = () => {
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", () => setWidth(window.innerWidth));

  if (width < 1000) {
    return (
      <MobileOverlay>
        <div style={{ width: "100%", maxWidth: "500px" }}>
          <Logo />
          <br />
          <Card>
            <p>Complete Cloud Control is currently not available on mobile devices.</p>
            <p>
              To view and create content on C3 we recommend a device
              with a larger screen, like a laptop or desktop pc.
            </p>
          </Card>
        </div>
      </MobileOverlay>
    );
  }

  return (
    <>
    <Launcher />
    <Container>
      <Sidebar />
      <Main>
        <AppNavbar />
        <WorkArea>
          <Switch>
            <Route path="/" exact component={Live} />
            <Route path="/live" exact component={Live} />
            <Route path="/signup" exact component={SignUp} />
            <Route path="/login" exact component={SignIn} />
            <Route path="/gallery" exact component={Gallery} />
            <Route path="/gallery/:id" exact component={Art} />
            <Route path="/scripts" exact component={Scripts} />
            <Route path="/scripts/:id" exact component={Script} />
            <Route path="/slideshows" exact component={Slideshows} />
            <Route path="/slideshows/:id" exact component={Slideshows} />
          </Switch>
        </WorkArea>
      </Main>
    </Container>
    </>
  );
};

export default withAuthentication(App);
